export default __webpack_public_path__ + "static/media/darkAwards.3158a3c0.svg";